import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const isLoggedIn = localStorage.getItem("isloggedin");
  const userModules = JSON.parse(localStorage.getItem("moduleSubmoduleDetails") || '[]');
  const redirectTo = localStorage.getItem('defaultRoute');

  console.log("RedirectTo:", redirectTo, "IsLoggedIn:", isLoggedIn);
  console.log("RequestedPath:", state.url);

  if (isLoggedIn !== 'true') {
    router.navigate(['login']);
    return false;
  }

  if (redirectTo && state.url !== '/orders') {
    router.navigate(['/orders']);
    return false;
  }

  return true;
};
